/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Controls/Close': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M17.415 16.001l6.01-6.009a.26.26 0 000-.366l-1.051-1.05a.258.258 0 00-.366 0L16 14.584 9.992 8.575a.26.26 0 00-.366 0L8.58 9.621a.257.257 0 000 .371l6.005 6.007-6.01 6.009a.258.258 0 000 .365l1.051 1.05c.1.102.265.102.366 0L16 17.416l6.008 6.01c.1.1.266.1.366 0l1.046-1.052a.251.251 0 000-.365l-6.005-6.007z"/>'
  }
})
